// =============================================================================
// src/core/osm-tiles.ts — Configuracao do basemap OpenStreetMap (open source).
//
// Substitui o antigo basemap CartoDB (light_all/dark_all) pelos tiles OFICIAIS do
// OpenStreetMap no mapa principal da aba Mapa. Centraliza URL, atribuicao e zoom max
// num unico ponto (rule 9: nomes externos em config unica).
//
// Proveniencia: URL canonica `tile.openstreetmap.org/{z}/{x}/{y}.png` e maxZoom 19
//   verificados via Context7 (/leaflet/leaflet, 2026-06-07). A atribuicao e
//   OBRIGATORIA pela Tile Usage Policy do OSM — por isso os mapas habilitam
//   attributionControl. OSM padrao NAO serve tiles @2x, entao sem `{r}`, e a URL
//   canonica nao usa `{s}` (sem subdomains).
// =============================================================================

/** URL canonica dos tiles do OpenStreetMap (sem retina/@2x, sem subdominio). */
export const OSM_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

/** Atribuicao obrigatoria pela Tile Usage Policy do OpenStreetMap. */
export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

/** Zoom maximo servido pelo OSM padrao. */
export const OSM_MAX_ZOOM = 19;
